import { useEffect, useRef } from "react";
import { telemetryWs } from "@/lib/wsClient";
import { useAuthStore } from "@/store/auth";

/**
 * Connects the telemetry WebSocket on mount, disconnects on unmount.
 * Safe to call from the top-level layout — idempotent on re-renders.
 */
export function useWebSocket() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const connected = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || connected.current) return;
    telemetryWs.connect();
    connected.current = true;

    return () => {
      telemetryWs.disconnect();
      connected.current = false;
    };
  }, [isAuthenticated]);
}
